import { z } from 'zod';

/**
 * Trimmed MET Norway Locationforecast 2.0 response (spec 11) — the API proxy
 * never forwards MET's full payload, only these fields. Nullable fields mean
 * "MET didn't report this for the hour" (e.g. gust, or an hour past the
 * hourly-resolution window), not "unknown vs. zero".
 */
export const weatherHour = z.object({
  ts: z.number(),
  airTempC: z.number(),
  windMs: z.number(),
  windGustMs: z.number().nullable(),
  windFromDeg: z.number(),
  precipMm: z.number().nullable(),
  symbol: z.string().nullable(),
});
export type WeatherHour = z.infer<typeof weatherHour>;

export const weatherResponse = z.object({
  updatedAt: z.number(),
  hours: z.array(weatherHour),
});
export type WeatherResponse = z.infer<typeof weatherResponse>;
